export default __webpack_public_path__ + "static/media/Mercenary's Arm-straps of the Painted Claw.2a9bb806.jpg";